import { VideoThemeClipTypeEnum } from '@/enums/VideoThemeClipEnum';
import {
  ComparableThemeClip,
  CustomThemeClipResponse,
  SelectedThemeClip
} from '@/types/CustomVideoThemeTypes';

export const DEFAULT_IMAGE_CLIP_DURATION = 5;
export const MIN_IMAGE_CLIP_DURATION = 5;
export const MAX_IMAGE_CLIP_DURATION = 20;

export const getEmptyClipsByType = (): Record<VideoThemeClipTypeEnum, SelectedThemeClip[]> => ({
  [VideoThemeClipTypeEnum.INTRO]: [],
  [VideoThemeClipTypeEnum.BACKGROUND]: [],
  [VideoThemeClipTypeEnum.MIDDLE]: [],
  [VideoThemeClipTypeEnum.OUTRO]: []
});

export const clipTypesForPayload = [
  VideoThemeClipTypeEnum.INTRO,
  VideoThemeClipTypeEnum.BACKGROUND,
  VideoThemeClipTypeEnum.OUTRO
];

export const mapClipsByTypeToComparable = (
  clipsByType: Record<VideoThemeClipTypeEnum, SelectedThemeClip[]>
): ComparableThemeClip[] =>
  clipTypesForPayload.flatMap((clipType) =>
    clipsByType[clipType].map((clip, index) => ({
      id: clip.id,
      type: clipType,
      assetId: clip.assetId,
      order: index + 1,
      duration: clip.duration
    }))
  );

export const mapApiClipsToComparable = (clips: CustomThemeClipResponse[]): ComparableThemeClip[] =>
  clips
    .filter((clip) => clipTypesForPayload.includes(clip.type as VideoThemeClipTypeEnum))
    .map((clip) => ({
      id: clip.id,
      type: clip.type as VideoThemeClipTypeEnum,
      assetId: clip.assetId,
      order: clip.order ?? 0,
      duration: clip.duration
    }))
    .sort((a, b) => {
      if (a.type === b.type) {
        return a.order - b.order;
      }

      return clipTypesForPayload.indexOf(a.type) - clipTypesForPayload.indexOf(b.type);
    });
